import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { takeUntil, Subject } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
@Component({
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    imports: [TranslateModule]
})
export class ErrorPageComponent implements OnInit{

  errorMessage = 'error.message_401';
  destroy$ = new Subject();
  missing_info!: 'G_P'| 'P' | 'G' | null;
  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.destroy$))
      .subscribe( queryParams => {
       // if (queryParams.errorCode) {
          this.errorMessage  = queryParams.errorCode;
          this.missing_info = queryParams.missingType;
      //  }
  });
  }
}
